export const DOCUMENT_STAGES = {
  DRAFT: "DRAFT",
  INTERNAL_REVIEW: "INTERNAL_REVIEW",
  SENT_FOR_FILLING: "SENT_FOR_FILLING",
  APPROVED: "APPROVED",
  SENT: "SENT",
  DECLINED: "DECLINED",
  COMPLETED: "COMPLETED",
};

export const DOCUMENT_ROLES = {
  ADMIN: "ADMIN",
  USER: "USER",
};

export const DOCUMENT_CTA = {
  SEND_FOR_ESIGN: {
    alias: "send-for-esign",
    icon: "share-square",
    title: "Send for eSign",
    subtitle:
      "Initiate eSignature process for signers already added in the document.",
    showLinkGenerationBtn: false,
    isRecommended: true,
    isNew: false,
  },
  SEND_TO_SOMEONE: {
    alias: "send-to-someone",
    icon: "paper-plane",
    title: "Send via email",
    subtitle:
      "Share this document for review via email and give permission to view or edit.",
    showLinkGenerationBtn: false,
    isRecommended: false,
    isNew: false,
  },
  MASTER_DOCUMENT: {
    alias: "master-doc",
    icon: "share-square",
    title: "Publish fillable form to web",
    subtitle:
      "Share the link or post it anywhere to collect data via easy to fill form documents and request e-consent.",
    showLinkGenerationBtn: true,
    isRecommended: false,
    isNew: false,
  },
};
